import { EGetMyHomeObjectsExists } from 'shared/actions/valuationTraps/types';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export const setMyHomeExists = actionGenerator<EGetMyHomeObjectsExists.setMyHomeExists, boolean>(
  EGetMyHomeObjectsExists.setMyHomeExists,
);

export const setEstimationExist = actionGenerator<EGetMyHomeObjectsExists.setEstimationExists, boolean>(
  EGetMyHomeObjectsExists.setEstimationExists,
);
